<app-modal title="API_INTERFACES.NEW" [loading]="loading" (submitClicked)="submit()" [closeText]="'CANCEL'"
           [submitText]="'SAVE'">
  <app-api-interface-form (formGroupOutput)="formGroup = $event"></app-api-interface-form>
</app-modal>
